import api from '@/store/api/scheduled-report'
import {mapLegacyPagination} from '@/store/utils'
import * as mutationTypes from './mutation-types'
import {map} from 'underscore'

// Modules
import scheduledReport from './scheduled-report'
import bundles from './bundles'
import centre from './centre'

const initialState = () => ({
    scheduledReports: {
        data: [],
        pagination: {}
    }
})

export default {
    namespaced: true,
    state: initialState(),
    modules: {
        scheduledReport,
        bundles,
        centre,
    },
    getters: {
        scheduledReports: state => {
            return map(state.scheduledReports.data, report => {
                const {time, frequency} = report.run_at
                const localTime = time

                return {
                    ...report,
                    run_at: `${frequency} at ${localTime}`
                }
            })
        },
        pagination: state => state.scheduledReports.pagination
    },
    actions: {
        /**
         * @param {{}} params
         * @returns {Promise<*>}
         */
        listScheduledReports: async ({ commit, dispatch}, params) => {
            try {

                const response = await api.listScheduledReports(params)
                const scheduledReports = {
                    ...response,
                    pagination: mapLegacyPagination(response.pagination)
                }
                commit(mutationTypes.SET_SCHEDULED_REPORTS, scheduledReports)

                return scheduledReports
            } catch (e) {
                const errorResponse = await dispatch('errors/addErrors', [e], {root: true})
                return Promise.reject(errorResponse[0])
            }
        },
        resetScheduledReports: ({commit}) => commit(mutationTypes.RESET_SCHEDULED_REPORTS)
    },
    mutations: {
        [mutationTypes.RESET_SCHEDULED_REPORTS]: (state) => Object.assign(state, initialState()),
        [mutationTypes.SET_SCHEDULED_REPORTS]: (state, data) => state.scheduledReports = data
    }
}
